import { CrossSVG } from '@sbercloud/uikit-product-icons';
import { ButtonFunction } from '@snack-uikit/button';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useAnalytics } from 'src/hooks/useAnalytics';

const MocksRu = {
  reset: 'Сбросить',
};

type Props = {
  filterKey: string;
  titleKey: string;
};

export function ResetButton({ filterKey, titleKey }: Props) {
  const { clickAnalytics } = useAnalytics();
  const { resetField } = useFormContext();

  const handleReset = (filterKey: string) => {
    resetField(filterKey, { defaultValue: [] });
  };

  return (
    <ButtonFunction
      label={MocksRu.reset}
      appearance="neutral"
      size="s"
      icon={<CrossSVG />}
      onClick={() => {
        clickAnalytics({
          action: 'click',
          clickZone: 'body',
          clickElement: 'button',
          clickContent: MocksRu.reset,
          uniqueId: `marketplace-filter-${titleKey}-reset`,
          transitionType: 'inside-link',
        });

        handleReset(filterKey);
      }}
    />
  );
}
